Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReplyContentParser
  parse: (replyJson) ->
    author = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAuthorParser()
      .parse(replyJson.author)

    reply = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReplyParser()
      .parse(replyJson)

    locationSummary = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessLocationSummaryParser()
      .parse(replyJson.location)

    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReplyContent(author, reply, locationSummary)
